import * as types from "../constants/NewsConstants";
import {
  createNews,
  uploadImage,
  fetchAllNews,
  deleteNews,
  updateNews,
} from "../services/NewsService";

export const addNews = (newsData) => async (dispatch) => {
  dispatch({ type: types.CREATE_NEWS_REQUEST });
  try {
    await createNews(newsData);
    dispatch({ type: types.CREATE_NEWS_SUCCESS });
  } catch (error) {
    dispatch({
      type: types.CREATE_NEWS_FAIL,
      payload:
        error.response?.data?.message ||
        error.message ||
        "Failed to create news",
    });
  }
};

export const uploadNewsImage = (file, slug) => async (dispatch) => {
  dispatch({ type: types.UPLOAD_IMAGE_REQUEST });
  try {
    const data = await uploadImage(file, slug);
    dispatch({ type: types.UPLOAD_IMAGE_SUCCESS, payload: data.url });
  } catch (error) {
    dispatch({
      type: types.UPLOAD_IMAGE_FAIL,
      payload:
        error.response?.data?.message ||
        error.message ||
        "Failed to upload image",
    });
  }
};

export const getNewsList = () => async (dispatch) => {
  dispatch({ type: types.FETCH_NEWS_REQUEST });
  try {
    const data = await fetchAllNews();
    dispatch({ type: types.FETCH_NEWS_SUCCESS, payload: data });
  } catch (error) {
    dispatch({
      type: types.FETCH_NEWS_FAIL,
      payload:
        error.response?.data?.message ||
        error.message ||
        "Failed to fetch news",
    });
  }
};

export const removeNews = (slug) => async (dispatch) => {
  dispatch({ type: types.DELETE_NEWS_REQUEST });
  try {
    await deleteNews(slug);
    dispatch({ type: types.DELETE_NEWS_SUCCESS, payload: slug });
  } catch (error) {
    dispatch({
      type: types.DELETE_NEWS_FAIL,
      payload:
        error.response?.data?.message ||
        error.message ||
        "Failed to delete news",
    });
  }
};

export const editNews = (slug, newsData) => async (dispatch) => {
  dispatch({ type: types.UPDATE_NEWS_REQUEST });
  try {
    await updateNews(slug, newsData);
    dispatch({ type: types.UPDATE_NEWS_SUCCESS });
  } catch (error) {
    dispatch({
      type: types.UPDATE_NEWS_FAIL,
      payload:
        error.response?.data?.message ||
        error.message ||
        "Failed to update news",
    });
  }
};

export const clearImageUrl = () => ({ type: types.CLEAR_IMAGE_URL });
export const resetNewsState = () => ({ type: types.RESET_NEWS_STATE });
